var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2069 5.0861L11.4144 2.29297C11.3215 2.20009 11.2113 2.12641 11.0899 2.07614C10.9686 2.02587 10.8385 2 10.7072 2C10.5759 2 10.4458 2.02587 10.3245 2.07614C10.2031 2.12641 10.0929 2.20009 10 2.29297L2.29313 10.0005C2.19987 10.093 2.12593 10.2031 2.0756 10.3245C2.02528 10.4458 1.99959 10.576 2.00001 10.7073V13.5005C2.00001 13.7657 2.10536 14.02 2.2929 14.2076C2.48043 14.3951 2.73479 14.5005 3.00001 14.5005H5.79313C5.9245 14.5009 6.05464 14.4752 6.17599 14.4249C6.29735 14.3746 6.40748 14.3006 6.50001 14.2073L14.2069 6.50047C14.2998 6.40761 14.3734 6.29736 14.4237 6.17602C14.474 6.05468 14.4999 5.92463 14.4999 5.79329C14.4999 5.66195 14.474 5.53189 14.4237 5.41055C14.3734 5.28921 14.2998 5.17896 14.2069 5.0861ZM12 7.29297L9.20688 4.50047L10.7069 3.00047L13.5 5.79297L12 7.29297Z",
    fill: "#845AFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/Marker.aa83e8113afb9ef5f3c827f4524385b1.svg";
export { ForwardRef as ReactComponent };